import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import { TelegramOtpSendState } from './types';

export const actions: ActionTree<TelegramOtpSendState, RootState> = {
  sendTelegramOtpMessage: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/lk-api/telegram-otp/send',
        data: data,
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
};
